import http from '@/support/plugin/axios'

export const

recoverPasswordByEmail = ( companyId, email ) => http.post(`users/recover-password?companyId=${companyId}&email=${email}`)